import { getTranslationMessage } from "./localeCatalog.js";

const ENGLISH_EVIDENCE = {
  official: {
    badge: "คำแปลอังกฤษทางการ — ตรวจสอบสถานะจากแหล่งเผยแพร่ได้",
    tone: "confirmed",
  },
  official_publisher_translation_purpose_only: {
    badge: "ฉบับอังกฤษจากผู้เผยแพร่ — ระบุว่าเพื่อการแปลเท่านั้น",
    tone: "caution",
    disclosure:
      "ผู้เผยแพร่ระบุว่าเอกสารนี้จัดทำเพื่อการแปลเท่านั้น จึงไม่ควรใช้แทนต้นฉบับภาษาไทยในการวินิจฉัยสถานะทางกฎหมาย",
  },
  official_publisher_unverified: {
    badge: "ฉบับอังกฤษจากผู้เผยแพร่ — ยังไม่ยืนยันสถานะทางกฎหมาย",
    tone: "caution",
    disclosure:
      "พบเอกสารภาษาอังกฤษจากผู้เผยแพร่ แต่ยังไม่มีหลักฐานเพียงพอให้ถือเป็นคำแปลทางการ",
  },
  lawyer_reviewed: {
    badge: "คำแปลอังกฤษผ่านการตรวจโดยนักกฎหมาย — ไม่ใช่ต้นฉบับ",
    tone: "reviewed",
  },
  edited: {
    badge: "คำแปลอังกฤษผ่านการแก้ไข — ยังไม่ยืนยันเป็นคำแปลทางการ",
    tone: "caution",
  },
  machine_draft: {
    badge: "ร่างคำแปลภาษาอังกฤษ — อยู่ระหว่างการตรวจทาน",
    tone: "warning",
    disclosure: null,
  },
};

function localizeEvidence(evidence, key, locale, exactDisclaimer = "") {
  if (!locale) return evidence;
  const message = getTranslationMessage(locale, key);
  return {
    ...evidence,
    badge: message.badge,
    disclosure: exactDisclaimer && key === "purposeOnly"
      ? `${message.disclosure} ${exactDisclaimer}`.trim()
      : message.disclosure || null,
  };
}

export function getTranslationEvidence(bundle, locale = null) {
  const expression = bundle?.expression || {};
  if (expression.language !== "en") {
    const base = {
      badge: "ต้นฉบับภาษาไทย",
      tone: "source",
      disclosure: null,
      status: "original",
    };
    return localizeEvidence(base, "original", locale);
  }

  const status =
    bundle?.translation_metadata?.status ||
    expression.translation_status ||
    "unknown";
  const metadata = bundle?.translation_metadata || {};
  const source = bundle?.source_item || {};
  const hasArchivedStatusEvidence = Boolean(
    metadata.source_manifest_sha256 &&
      source.sha256 &&
      (source.resolved_url || source.request_url),
  );
  const officialPurposeOnly = (bundle?.warnings || []).some((warning) =>
    /for_translation_purpose_only|not_authoritative/i.test(warning),
  );
  if (status === "official" && officialPurposeOnly) {
    return localizeEvidence({
      ...ENGLISH_EVIDENCE.official_publisher_translation_purpose_only,
      disclosure:
        "ข้อมูลกำกับเอกสารระบุว่าเผยแพร่เพื่อการแปลเท่านั้น จึงไม่ใช้แทนต้นฉบับภาษาไทยในการวินิจฉัยสถานะทางกฎหมาย",
      status,
    }, "purposeOnly", locale);
  }
  if (status === "official" && !hasArchivedStatusEvidence) {
    return localizeEvidence({
      badge: "ข้อความภาษาอังกฤษ",
      tone: "warning",
      disclosure: null,
      status,
    }, "unverified", locale);
  }
  const evidence = ENGLISH_EVIDENCE[status];
  if (!evidence) {
    return localizeEvidence({
      badge: "ข้อความภาษาอังกฤษ",
      tone: "warning",
      disclosure: null,
      status,
    }, "unknown", locale);
  }

  const exactDisclaimer = metadata.disclaimer_exact;
  const localizedKey = {
    official: "official",
    lawyer_reviewed: "reviewed",
    edited: "edited",
    machine_draft: "draft",
    official_publisher_translation_purpose_only: "purposeOnly",
    official_publisher_unverified: "unverified",
  }[status] || "unknown";
  return localizeEvidence({
    ...evidence,
    disclosure:
      status === "official_publisher_translation_purpose_only" && exactDisclaimer
        ? `${evidence.disclosure} ข้อความกำกับในไฟล์: “${exactDisclaimer}”`
        : evidence.disclosure || null,
    status,
  }, localizedKey, locale, exactDisclaimer);
}
